import { Component, OnInit } from '@angular/core';
import { AppConfig } from '../../_config';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {

  public landingPageUrl = '';
  constructor(appConfig:AppConfig) {
    this.landingPageUrl = appConfig.LandingPageUrl;
   }

  ngOnInit() {
  }

}
